import { skipToken } from "@tanstack/react-query";
import { can } from "@remi/permissions";

import { api } from "~/utils/api";
import { useUserProfile } from "~/contexts/UserProfileContext";

export const usePersonNotes = (personId?: string) => {
  const { user } = useUserProfile();
  return api.person.notes.useQuery(personId ? { personId } : skipToken, {
    enabled: can.person.viewDetails(user),
  });
};
export const useCreatePersonNote = () => {
  const utils = api.useUtils();
  return api.person.createNote.useMutation({
    onSuccess: (note) => {
      void utils.person.notes.invalidate({ personId: note.personId });
    },
  });
};
export const useSetIsNotePinned = () => {
  const utils = api.useUtils();
  return api.person.setIsNotePinned.useMutation({
    onSuccess: (note) => {
      void utils.person.notes.invalidate({ personId: note.personId });
    },
  });
};
